import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { maxLength, minLength } from '@angular/forms/signals';

@Component({
    selector: 'rqa-field-error',
    standalone: true,
    templateUrl: './field-error.component.html',
    changeDetection: ChangeDetectionStrategy.Eager
})
export class FieldErrorComponent {
    control = input<AbstractControl | null>(null);
    customMessage = input<string>();

    get errorMessage(): string {
        const ctrl = this.control();

        if (!ctrl?.invalid || (!ctrl.touched && !ctrl.dirty)) {
            return '';
        }

        return this.customMessage() || this.getErrorMessage(ctrl.errors) || '';
    }


    getErrorMessage(errors: ValidationErrors | null): string | null {
        if (!errors) {
            return null;
        }

        const errorMap: Record<string, (error: any) => string> = {
            required: () => 'Pole jest wymagane.',
            email: () => 'Podaj poprawny adres e-mail.',
            pattern: () => 'Wprowadzona wartość ma nieprawidłowy format.',
            min: (e) => `Wartość musi być większa lub równa ${e.min}.`,
            max: (e) => `Wartość musi być mniejsza lub równa ${e.max}.`,
            minlength: (e) => `Wartość musi mieć przynajmniej ${e.requiredLength} znaków.`,
            maxlength: (e) => `Wartość musi mieć maksymalnie ${e.requiredLength} znaków.`,
        };

        const firstErrorKey = Object.keys(errors)[0];

        const formatter = errorMap[firstErrorKey];

        return formatter
            ? formatter(errors[firstErrorKey])
            : 'Niepoprawna wartość.';
    }
}